import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/**
 * Composant de input password
 * @extends BaseInputComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.scss']
})
export class InputPasswordComponent implements OnInit {
    @Input() placeholder: string = '';
    @Input() tabindex: number = null;

    @Input() value: string = '';
    @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

    showPassword: boolean = false;

    /**
     * Constructeur
     */
    constructor() {}

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Ev�nement onChange
     */
    onChange() {
        this.valueChange.emit(this.value);
    }
}
